module.exports = __webpack_public_path__ + "static/sport/bgi-dialog.27cccc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sinh/bgi-dialog.png
// module id = 2MoR
// module chunks = 0